import React from 'react';
import PolymarketDistributionCard from './PolymarketDistributionCard';

function AnnualRateCutsCard({ data }) {
  const subtitle = (
    <>
      Polymarket-implied · expected ≈{' '}
      <span className="text-blue-300 font-semibold">{data?.expected_cuts ?? '—'}</span> cuts
      {data?.total_volume ? ` · $${Math.round(data.total_volume).toLocaleString()} volume` : ''}
    </>
  );

  return (
    <PolymarketDistributionCard
      data={data}
      title={`How many Fed rate cuts in ${data?.year ?? ''}?`}
      subtitle={subtitle}
      unavailableTitle="Annual outlook"
    />
  );
}

export default AnnualRateCutsCard;
